import toPixels from 'utils/toPixels'

export default async function saveFile({ props, state, graphql }) {
  const { orderItemId } = props
  const { target, form } = state.get(`basket.basketItems.${orderItemId}`)
  const unit = state.get('basket.unit')
  const size = toPixels(unit, target.dpi, form.width.value)

  await graphql.mutate(`{
    editTargetWidth(width: ${size}, orderItemId: "${orderItemId}")
  }`)
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/saveSize.js